import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CouponMiniEntity } from '../../domain/entities/CouponMiniEntity'

export class CouponMiniModel extends CouponMiniEntity {
    redeemCode =''
    validFrom =''
    validTo =''
    maxUsageCount = 0
    maxUsagePerUser = 0 
  constructor(dataDto: CouponMiniEntity) {
    super()
    mapEntityProperties<CouponMiniEntity>(this, dataDto)
  }
}
